import LcabApiResult from "./LcabApiResult";
import AbstractEntity, {AbstractEntityBuilder} from "~/ts/library/AbstractEntity";
import AbstractApiRequest, {ApiRequestConfig} from "~/core-ui/ts/request/AbstractApiRequest";
import LcabApiFetchListResult from "~/cabinet/ts/api/LcabApiFetchListResult";

interface LcabApiRequestConfig extends ApiRequestConfig {
}

export {LcabApiRequestConfig};

export default class LcabApiRequest<DataType extends object> extends AbstractApiRequest<LcabApiResult<DataType>, DataType> {
    private static cabinetUrlPrefix = "";

    public static getUrl(path: string): string {
        if (path.indexOf("/cmd/") !== 0 && path.indexOf("/json/") !== 0) {
            path = this.getCabinetUrlPrefix() + path;
        }
        return path;
    }

    public static getCabinetUrlPrefix(): string {
        return this.cabinetUrlPrefix;
    }

    public static setCabinetUrlPrefix(value: string): void {
        this.cabinetUrlPrefix = value;
    }

    protected getUrl(path: string): string {
        return LcabApiRequest.getUrl(path);
    }

    protected createApiResultByResponse(response: any, dataType?: AbstractEntityBuilder<DataType>): LcabApiResult<DataType> {
        return new LcabApiResult(response, dataType);
    }

    static async save<T extends object>(options: LcabApiRequestConfig) {
        options.saving = true;
        let result = await (new this<T>(options)).send();
        result.showMessage();
        return result;
    }

    static async fetchList<T extends AbstractEntity>(options: LcabApiRequestConfig, dataType?: AbstractEntityBuilder<T>): Promise<LcabApiFetchListResult<T>> {
        if (options.loading == null) {
            options.loading = true;
        }
        let result = await (new this(options)).send();
        return new LcabApiFetchListResult<T>(result, dataType);
    }

    async send<T>(): Promise<LcabApiResult<DataType>> {
        this.addHeader("X-filters-without-operations", "1");
        return super.send();
    }

    static async fetch<T extends object>(options: LcabApiRequestConfig, dataType?: AbstractEntityBuilder<T>): Promise<LcabApiResult<T>> {
        options.loading = true;
        return (new this<T>(options, dataType)).send();
    }

}

